<template>
  <div class="flex flex-col gap-0.5rem min-w-360px">
    <p class="mb-2 text-14px">单击您要执行的操作:</p>

    <n-button tertiary @click="emitSelect('delete-subassembly')">
      <n-text strong>
        删除子装配体
      </n-text>
      <n-text depth="3">
        从顶级装配体中删除包含选定零部件的子装配体
      </n-text>
    </n-button>

    <n-button tertiary @click="emitSelect('delete-selected-component')">
      <n-text strong>
        仅删除选定的零部件
      </n-text>
      <n-text depth="3">
        删除子装配体中的选定零部件
      </n-text>
    </n-button>
  </div>
</template>

<script setup lang="ts">
/**
 * 装配组件删除范围。
 */
type AssemblyComponentDeleteScope =
  | 'delete-subassembly'
  | 'delete-selected-component';

/**
 * 删除范围选择事件。
 */
interface AssemblyComponentDeleteScopeDialogEmits {
  /**
   * 用户选择了删除范围。
   *
   * @param event 事件名。
   * @param scope 删除范围。
   * @param doNotShowAgain 是否请求后续不再显示范围选择。
   */
  (event: 'select', scope: AssemblyComponentDeleteScope, doNotShowAgain: boolean): void;
}

const emit = defineEmits<AssemblyComponentDeleteScopeDialogEmits>();

/**
 * 派发删除范围选择。
 *
 * @param scope 删除范围。
 */
function emitSelect(scope: AssemblyComponentDeleteScope): void {
  emit('select', scope, false);
}
</script>

<style scoped lang="less">
.n-button{
  height:60px;
  justify-content: start;

  :deep(.n-button__content){
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    height: max-content;
    gap: 10px;
    flex-wrap: wrap;
  }
}
</style>
